import { Icon } from "@iconify/react/dist/iconify.js";
import React from "react";

const DengerAlert = ({ message, onClose }) => {
  if (!message) return null;

  return (
    <div className="alert-container">
      <div
        className="alert alert-danger bg-danger-100 text-danger-600 border-danger-600 
                   border-start-width-4-px px-24 py-13 fw-semibold text-lg radius-4 
                   d-flex align-items-center justify-content-between position-fixed top-0 end-0 mt-3 me-3"
        role="alert"
        style={{ zIndex: 1050, minWidth: "300px" }}
      >
        <div className="d-flex align-items-center gap-2">{message}</div>
        <button
          className="remove-button text-danger-600 text-xxl line-height-1"
          onClick={onClose}
        >
          <Icon icon="iconamoon:sign-times-light" className="icon" />
        </button>
      </div>
    </div>
  );
};

export default DengerAlert;
